import { render, staticRenderFns } from "./PlayerBirthday.vue?vue&type=template&id=0830b6bd&scoped=true&"
import script from "./PlayerBirthday.vue?vue&type=script&lang=js&"
export * from "./PlayerBirthday.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBirthday.vue?vue&type=style&index=0&id=0830b6bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830b6bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/usr/src/regapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VFlex,VForm,VLayout,VSelect})
